import { useEntityUrl } from 'framework/routing';
import { SERVICE_PATH } from '../serviceService';

export const useServiceUrl = () => {
  return useEntityUrl({
    baseLink: SERVICE_PATH,
  });
};
